// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import {
  LIBRARY,
  CREATION,
  REPORTING,
  PRICE_BRACKET,
  PRICE_ELASTICITY,
  SWITCHING_MATRIX,
} from 'src/app/shared/static';

export const environment = {
  production: false,
  environmentName: 'dev',
  api_base_url: 'https://ppa-pvp-backend-demo.azurewebsites.net/',
  client_id: '7dc82d6a-6d20-4643-a6a5-2cdeef5bcb49',
  tenant_autority:
    'https://login.microsoftonline.com/77184d99-6065-42b9-9452-8b2b70385193',
  redirect_url: 'https://ppa-pvp-frontend-demo.azurewebsites.net/auth-response',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

export const NAV_ITEMS = [
  {
    name: 'PRICE SIMULATOR',
    description: `Browse through the scenario's 
created by other users`,
    route: LIBRARY,
    img: 'library.svg',
    disabled: false,
  },
];
